import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  container: {
    ...theme.mixins.appContainer,
    display: 'flex',
    gap: 8,
    marginBottom: 8,
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    justifyContent: 'center',
  },
  detailsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    alignItems: 'flex-start',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
      alignItems: 'stretch',
    },
  },
  postsWrapper: {
    flex: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  cardContainer: {
    ...theme.mixins.appContainer,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  newPostHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  newPostHeaderText: {
    flex: 1,
  },
  newPostInput: {
    width: '100%',
    height: 40,
    borderRadius: theme.spacing(1),
  },
  newPostActions: {
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  postHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  postHeaderText: {
    flex: 1,
  },
  postMediaPlaceholder: {
    width: '100%',
    height: 168,
    borderRadius: theme.spacing(1),
  },
  postFooter: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  relationsWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    minWidth: 280,
    [theme.breakpoints.down('md')]: {
      minWidth: '100%',
    },
  },
  relationList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  relationListRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-start',
    },
  },
}));
